class AccessCardsForm {
    constructor(formID, accessCardsInstance = null, accessCardInfo = null, goToStep = null) {
        this.accessCardsInstance = accessCardsInstance;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.form = document.getElementById(formID);
        this.modal = this.form.querySelector('.modal');
        this.accessCardInfo = accessCardInfo;
        this.stepValidators = null;
        this.repeater = null;
        this.accessCardMembersAndGroups = null;
        this.accessCardSystemsAndBranches = null;

        if(this.modal && this.form){
            this.initStepper(goToStep);
        }
    }
    initStepper(goToStep){
        const thisClass = this;
        /** Prevent modal from closing when click outside the modal */
        this.modal.addEventListener('shown.bs.modal', function (event) {
            new DismissModal(thisClass.modal.id).disable(true);
        });

        this.initDatatables();

        /** Init stepper with validation */
        const element = this.form.querySelector("#access_card_modal_stepper");
        const stepper = new KTStepper(element);
        $(this.form.querySelector('select[name="timezone"]')).select2();
        this.initExpiresOnDatePicker();
        this.initSelectDays();
        this.accessCardFormValidation();

        if(goToStep){
            stepper.goTo(goToStep);
        }

        /** If you click on a step in the stepper */
        stepper.on("kt.stepper.click", async function (stepper) {
            let indexToGo = stepper.getClickedStepIndex();
            let isCurrentStepValid = await thisClass.getIfStepIsValid(stepper);
            /** Check if current step is valid */
            /** If I go back, I may not have a valid current step */
            if (isCurrentStepValid || stepper.currentStepIndex > indexToGo) {
                stepper.goTo(indexToGo);
            }
        });
        /** Go next */
        stepper.on("kt.stepper.next", async function (stepper) {
            let isCurrentStepValid = await thisClass.getIfStepIsValid(stepper);
            if (isCurrentStepValid) {
                stepper.goNext();
            }
        });
        /** Go previous step */
        stepper.on("kt.stepper.previous", function (stepper) {
            stepper.goPrevious();
        });

        /** Init submit form */
        this.initSubmitForm(stepper);
    }
    initDatatables(){
        /** Add loading for the whole modal content */
        const blockUI = new KTBlockUI(this.modal.querySelector('.modal-content'), {
            overlayClass: "ga-bg-primary-200",
        });
        blockUI.block();

        let tablesRendered = 0;
        const checkTablesRendered = function() {
            tablesRendered++;
            if (tablesRendered === 2) {
                /** Remove modal loading - everything is set */
                blockUI.release();
            }
        }

        $('#'+this.modal.id + ' #systems-and-branches-datatable').on('init.dt', function() {
            checkTablesRendered();
        });

        $('#'+this.modal.id + ' #members-and-groups-datatable').on('init.dt', function() {
            checkTablesRendered();
        });

        this.accessCardSystemsAndBranches = new AccessCardSystemsAndBranches(this.form, this.modal, this.accessCardInfo);
        this.accessCardMembersAndGroups = new AccessCardMembersAndGroups(this.form, this.modal, this.accessCardInfo);
    }
    initExpiresOnDatePicker(){
        const thisClass = this;
        let expiresOn = this.form.querySelector('input[name="expiresOn"]');
        let expirationEl = thisClass.form.querySelector('#expires-in-text');

        const setExpirationText = function (expirationEl, expiration){
            if(expirationEl){
                let expirationText = thisClass.getExpirationMessage(expiration);
                if(expirationEl && expirationText){
                    expirationEl.classList.remove('d-none');
                    expirationEl.innerHTML = `
                            <span class="text-muted">${expirationText.mutedText}</span>
                            <span class="text-danger fw-bold">${expirationText.dangerText}</span>
                        `;
                }
            } else if(expirationEl){
                expirationEl.classList.add('d-none');
            }
        }

        if(expiresOn){
            const later = new Date();
            later.setMinutes(Math.ceil((new tempusDominus.DateTime().minutes) / 30) * 30);
            let expiresOnPicker = $(expiresOn).daterangepicker({
                singleDatePicker: true,
                timePicker: true,
                timePicker24Hour: true,
                timePickerSeconds: false,
                timePickerIncrement: 30,
                showDropdowns: true,
                minDate: later,
                locale: {
                    format: "MM/DD/YYYY HH:mm",
                    cancelLabel: 'Clear'
                },
                parentEl: $(this.modal)
            }, function(start, label) {
                setExpirationText(expirationEl, start);
            });
            if(this.accessCardInfo && this.accessCardInfo['expiresAt']){
                let expiresAt = moment.parseZone(this.accessCardInfo['expiresAt']).format('MM/DD/YYYY HH:mm');
                let laterFormatted =  moment(later).format('MM/DD/YYYY HH:mm');
                if(laterFormatted > expiresAt){
                    expiresAt = laterFormatted;
                }
                expiresOnPicker.data('daterangepicker').setStartDate(expiresAt);
                setExpirationText(expirationEl, expiresAt);
            } else {
                expiresOnPicker.val('');
                if(expirationEl){
                    expirationEl.classList.add('d-none');
                }
            }
            $(expiresOn).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
                if(expirationEl){
                    expirationEl.classList.add('d-none');
                }
            });
        }
    }
    getExpirationMessage(expirationTime) {
        const now = new Date();
        const expirationDate = new Date(expirationTime);

        if (isNaN(expirationDate)) {
            return null;
        }

        const diffInMilliseconds = expirationDate - now;

        if (diffInMilliseconds > 0) {
            const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
            const isSameDay =
                now.getFullYear() === expirationDate.getFullYear() &&
                now.getMonth() === expirationDate.getMonth() &&
                now.getDate() === expirationDate.getDate();

            if (isSameDay) {
                return {
                    mutedText: 'Expires ',
                    dangerText: 'today'
                }
            } else {
                return {
                    mutedText: 'Expires in ',
                    dangerText: `${diffInDays + 1} day${diffInDays + 1 > 1 ? "s" : ""}`
                }
            }
        } else {
            const diffInDays = Math.ceil(Math.abs(diffInMilliseconds) / (1000 * 60 * 60 * 24));
            const isSameDay =
                now.getFullYear() === expirationDate.getFullYear() &&
                now.getMonth() === expirationDate.getMonth() &&
                now.getDate() === expirationDate.getDate();

            if (isSameDay) {
                return {
                    mutedText: 'Expired ',
                    dangerText: 'today'
                }
            } else {
                return {
                    mutedText: 'Expired ',
                    dangerText: `${diffInDays - 1} day${diffInDays - 1 > 1 ? "s" : ""} ago`
                }
            }
        }
    }
    initDatePickers(inputs){
        const thisClass = this;

        if(inputs.activeFrom && inputs.activeTo){
            flatpickr(inputs.activeFrom, {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                minuteIncrement: 30,
                defaultHour: 0,
                defaultMinute: 0,
                appendTo: thisClass.form,
                disableMobile: true,
                onChange: function(selectedDates, dateStr, instance) {
                    let date = dateStr.split(':');
                    let minutes = Math.ceil((parseInt(date[1])) / 5) * 5;
                    this.setDate(date[0]+':'+minutes);
                },
            });
            flatpickr(inputs.activeTo, {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                minuteIncrement: 30,
                defaultHour: 0,
                defaultMinute: 0,
                appendTo: thisClass.form,
                disableMobile: true,
                onChange: function(selectedDates, dateStr, instance) {
                    let date = dateStr.split(':');
                    let minutes = Math.ceil((parseInt(date[1])) / 5) * 5;
                    this.setDate(date[0]+':'+minutes);
                },
            });

            // This must be there because of netteForms validation, which validates every input type number without rules.
            // Therefore, for proper functioning, the input needs to be mapped to text
            let flatpickerNumberInputs = document.querySelectorAll('.flatpickr-calendar.hasTime.noCalendar .numInputWrapper .numInput');
            flatpickerNumberInputs.forEach((element) => {
                element.type = "text";
            });
        }
    }
    initSelectDays(){
        const thisClass = this;
        let counter = 0;

        this.repeater = $(this.form).find('#time-slot-repeater').repeater({
            initEmpty: true,
            show: function () {
                counter++;
                let inputs = {
                    activeFrom: $(this).find('input[data-repeater="active-from"]'),
                    activeTo: $(this).find('input[data-repeater="active-to"]'),
                    allDay: $(this).find('input[data-repeater="all-day"]'),
                    day: $(this).find('input[data-repeater="day-number"]')
                }

                $(this).find('[data-repeater="day-name"]').html(inputs.day.val()+':');
                inputs.allDay.attr('id', 'allDay'+counter)
                $(this).find('[data-repeater="all-day-label"]').attr('for', 'allDay'+counter);

                thisClass.initDatePickers(inputs);

                const disableActiveInputs = function (inputs) {
                    inputs.activeFrom.val("");
                    inputs.activeTo.val("");
                    inputs.activeFrom.prop('disabled', true);
                    inputs.activeTo.prop('disabled', true);
                    inputs.activeFrom.addClass('cursor-not-allowed');
                    inputs.activeTo.addClass('cursor-not-allowed');
                };

                if(inputs.allDay[0].checked){
                    disableActiveInputs(inputs);
                }

                inputs.allDay.on('change', function () {
                   if(this.checked){
                       disableActiveInputs(inputs);
                   } else {
                       inputs.activeFrom.prop('disabled', false);
                       inputs.activeTo.prop('disabled', false);
                       inputs.activeFrom.removeClass('cursor-not-allowed');
                       inputs.activeTo.removeClass('cursor-not-allowed');
                   }
                });

                $(this).slideDown();
            },
            hide: function (deleteElement) {
                $(this).slideUp(deleteElement, function() {
                    // Remove active from day button
                    let dayNumber = $(this).find('input[data-repeater="day-number"]').val();
                    thisClass.form.querySelector('.btn[data-kt-days-button="true"][data-number="'+dayNumber+'"]').classList.remove('active');

                    // Remove time slot row
                    $(this).remove();
                    thisClass.accessCardFormValidation();
                });
            },
        });

        if(this.accessCardInfo && this.accessCardInfo.activeInDays){
            let list = [];
            for (const [key, value] of Object.entries(this.accessCardInfo.activeInDays)) {
                let values = {
                    'allDay': value.allDay === 1 ? 'on' : 'off',
                    'day': value.day
                }
                if(value.activeFrom){
                    values.activeFrom = value.activeFrom;
                }
                if(value.activeTo){
                    values.activeTo = value.activeTo;
                }
                list.push(values);
            }
            this.repeater.setList(list);
        }

        let addButton = this.form.querySelector('[data-repeater-create]');
        let selectDaysBtn = this.form.querySelectorAll('.btn[data-kt-days-button="true"]');
        selectDaysBtn.forEach((element) => {
            element.addEventListener('click', function () {
                if(element.classList.contains('active')){
                    // Remove
                    let dayNumber = element.attributes['data-number'].value;
                    let dayNumberInput = thisClass.form.querySelector('.time-slot-row input[data-repeater="day-number"][value="'+dayNumber+'"]');
                    if(dayNumberInput){
                        let timeslotRow = dayNumberInput.closest(".time-slot-row");
                        if(timeslotRow){
                            timeslotRow.querySelector('[data-repeater-delete]').click();
                        }
                    }

                    element.classList.remove('active');
                } else {
                    // Add
                    addButton.click();
                    let addedRow = thisClass.form.querySelector("[data-repeater-item]:last-child");
                    addedRow.querySelector('[data-repeater="day-name"]').innerText = element.attributes['data-name'].value+':';
                    addedRow.querySelector('input[data-repeater="day-number"]').value = element.attributes['data-number'].value;

                    element.classList.add('active');

                    thisClass.accessCardFormValidation();
                }
            });
        });
    }
    getIfStepIsValid(stepper, stepIndex = null){
        return new Promise((resolve) => {
            switch (stepIndex ?? stepper.currentStepIndex) {
                case 3:
                    this.stepValidators.step3Validator.validate().then(function (status) {
                        resolve(status === 'Valid');
                    });
                    break;
                case 'name':
                    this.stepValidators.nameValidator.validate().then(function (status) {
                        resolve(status === 'Valid');
                    });
                    break;
                default:
                    resolve(true);
            }
        });
    }
    accessCardFormValidation(){
        let thisClass = this;
        let nameValidator, step3Validator;

        if(this.stepValidators){
            this.stepValidators.nameValidator.destroy();
            this.stepValidators.step3Validator.destroy();
        }

        nameValidator = FormValidation.formValidation(thisClass.form,
            {
                fields: {
                    'name': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                            stringLength: {
                                max: 45,
                                message: 'Name cannot be over 45 characters',
                            },
                            regexp: {
                                regexp: /^[ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zA-Z0-9#\' _.-]*$/,
                                message: 'Only these special characters are allowed. (_-)',
                            },
                        }
                    }
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                }
            },
        );

        step3Validator = FormValidation.formValidation(thisClass.form,
            {
                fields: {
                    'timezone': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                        },
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: '',
                        defaultMessageContainer: false
                    }),
                    message: new FormValidation.plugins.Message({
                        clazz: 'fv-plugins-message-container invalid-feedback',
                        container: function (field, ele) {
                            if (field.includes('allDay') || field.includes('activeFrom') || field.includes('activeTo')) {
                                return FormValidation.utils.closest(ele, '.time-slot-row').querySelector('.all-day-message-container');
                            }
                            return FormValidation.utils.closest(ele, '.fv-row');
                        }
                    }),
                }
            },
        );

        this.form.querySelectorAll('.time-slot-row').forEach((timeSlot) => {
            let inputs = {
                allDay: timeSlot.querySelector('input[data-repeater="all-day"]'),
                activeFrom: timeSlot.querySelector('input[data-repeater="active-from"]'),
                activeTo: timeSlot.querySelector('input[data-repeater="active-to"]'),
            }

            if(inputs.allDay){
                step3Validator.addField(inputs.allDay.attributes.name.value, {
                    validators: {
                        callback: {
                            message: 'Select all day or specific time',
                            callback: function (input) {
                                return input.element.checked || !!(inputs.activeFrom.value || inputs.activeTo.value);
                            }
                        }
                    }
                });
            }
            if(inputs.activeFrom){
                step3Validator.addField(inputs.activeFrom.attributes.name.value, {
                    validators: {
                        callback: {
                            message: 'Active from must be before active to',
                            callback: function (input) {
                                if(inputs.activeTo.value && !input.value){
                                    return false;
                                }
                                if(input.value && inputs.activeTo.value){
                                    return inputs.activeFrom.value < inputs.activeTo.value;
                                }
                                return true;
                            }
                        }
                    }
                });
            }
            if(inputs.activeTo) {
                step3Validator.addField(inputs.activeTo.attributes.name.value, {
                    validators: {
                        callback: {
                            message: 'This field is required',
                            callback: function (input) {
                                if(inputs.activeFrom.value){
                                    return input.value !== '';
                                }
                                return true;
                            }
                        }
                    }
                });
            }
        });

        this.stepValidators = {
            nameValidator: nameValidator,
            step3Validator: step3Validator
        }
    }
    initSubmitForm(stepper){
        const thisClass = this;
        let submitButton = this.form.querySelector('[data-kt-stepper-custom-action="submit"]');
        /** If the submit button is clicked, check if all steps are valid and if so, submit the form. */
        submitButton.addEventListener('click', async function (e) {
            e.preventDefault();
            new DismissModal(thisClass.modal.id).disable();
            // Show loading indication
            submitButton.setAttribute('data-kt-indicator', 'on');
            // Disable button to avoid multiple click
            submitButton.disabled = true;

            let isStep3Valid = await thisClass.getIfStepIsValid(stepper, 3);
            let isNameValid = await thisClass.getIfStepIsValid(stepper, 'name');
            if(isStep3Valid && isNameValid){
                $(thisClass.form).submit();
            } else {
                new DismissModal(thisClass.modal.id).enable();
                new DismissModal(thisClass.modal.id).disable(true);
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            }
        });

        let context = $.nette.ext(thisClass.form.id);
        if(!context){
            $.nette.ext(thisClass.form.id, {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === thisClass.form.id){
                        thisClass.modal = document.getElementById(thisClass.modal.id);

                        if(payload.status === 'success'){
                            toastr.success(payload.message);
                        } else if(payload.status ==='warning'){
                            toastr.error(payload.message);
                        }

                        new DismissModal(thisClass.modal.id).enable();
                        bootstrap.Modal.getOrCreateInstance(thisClass.modal).hide();

                        if(thisClass.accessCardsInstance){
                            thisClass.accessCardsInstance.getAccessCards(); // Create access card form
                        } else if(typeof accessCardsInstance !== 'undefined') {
                            accessCardsInstance.getAccessCards();  // Edit access card form at /access-cards
                        } else {
                             // different site
                            new PageDatatableReload(false);
                        }

                        // Cancel loading indication
                        let submitButton = thisClass.form.querySelector('[data-kt-stepper-custom-action="submit"]');
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;

                        thisClass.clearForm();
                    }
                }
            });
        }
    }
    clearForm(){
        this.accessCardMembersAndGroups.resetDatatable();
        this.accessCardSystemsAndBranches.resetDatatable();

        let nameElement = this.form.querySelector('input[name="name"]');
        nameElement.value = this.getNewAccessCardName(nameElement.value);
        this.form.querySelector('input[name="expiresOn"]').value = '';

        this.form.querySelector('#expires-in-text').classList.add('d-none');

        this.repeater.setList([]);

        let activeInDays = this.form.querySelectorAll('.active[data-kt-days-button="true"]');
        activeInDays.forEach((element) => {
            element.classList.remove('active');
        });

        const stepperElement = this.form.querySelector("#access_card_modal_stepper");
        let stepper = KTStepper.getInstance(stepperElement);
        stepper.goTo(1);
    }
    getNewAccessCardName(name) {
        const regex = /^Access Card #(\d+)$/;
        const match = name.match(regex);
        if (match) {
            const number = parseInt(match[1], 10);
            const incrementedNumber = number + 1;
            return `Access Card #${incrementedNumber}`;
        }
        return '';
    }
}
window.AccessCardsForm = AccessCardsForm;